<template>
    <nav>
        <v-layout>
            <v-toolbar id="menu" flat app class="simple-toolbar">
                <v-btn class="text-capitalize font-weight-bold" flat to="/">
                    <span class="menu-btn">Home</span>
                        </v-btn>
                </v-toolbar>
            </v-layout>   
        <router-view></router-view>         
    </nav>
</template>

<script>
    export default {
        name: 'SimpleLayout'
        
    }
</script>

<style>
    .simple-toolbar .menu-btn {
        font-size: 30px!important;
    }
</style>
